import { HuskyAddToListModalState } from "@husky-hrc/Framework/Store/Data/AddToListModal/AddToListModalState";
import Constants from "@husky-hrc/Utilities/Constants";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: HuskyAddToListModalState = {
    isOpen: false,
    getWishListsParameter: {
        filter: "availableToAdd",
        pageSize: 100,
    },
    productConfigId: "",
};

const reducer = {
    [Constants.Actions.CompleteSetAddToListModalIsOpen]: (
        draft: Draft<HuskyAddToListModalState>,
        action: {
            isOpen: boolean;
            productInfos?: Omit<ProductInfo, "productDetailPath">[];
            configId?: string;
        },
    ) => {
        if (!action.isOpen) {
            return initialState;
        }

        draft.isOpen = action.isOpen;
        draft.productInfos = action.productInfos;
        draft.productConfigId = action.configId || "";
    },
};

const addToListModalReducer = createTypedReducerWithImmer(initialState, reducer);
export default addToListModalReducer;

// This line is important as it adds the reducer to the reducers collection on the Store.
(reducers as any).addToListModal = addToListModalReducer;
